export default __webpack_public_path__ + "images/assets/fd5e0f7758b84d6480716810cc5b5c65.svg";